export default __webpack_public_path__ + "static/media/foodlogiq.5211f145.svg";